"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryString = exports.stringifyQuery = exports.parseSearchParams = void 0;
const qs_1 = require("qs");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const parseSearchParams = (searchParams, parseOptions) => (0, qs_1.parse)(searchParams.toString(), parseOptions !== null && parseOptions !== void 0 ? parseOptions : {
    ignoreQueryPrefix: true,
});
exports.parseSearchParams = parseSearchParams;
const stringifyQuery = (query, stringifyOptions) => (0, qs_1.stringify)(query, stringifyOptions !== null && stringifyOptions !== void 0 ? stringifyOptions : {
    encodeValuesOnly: true,
    skipNulls: true,
});
exports.stringifyQuery = stringifyQuery;
const useQueryString = ({ parseOptions, stringifyOptions, } = {}) => {
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const query = (0, react_1.useMemo)(() => (0, exports.parseSearchParams)(searchParams, parseOptions), [parseOptions, searchParams]);
    const setQuery = (0, react_1.useCallback)((queryOrFunc) => {
        setSearchParams((prevSearchParams) => {
            if (typeof queryOrFunc === 'function') {
                const prevQuery = (0, exports.parseSearchParams)(prevSearchParams, parseOptions);
                const newQuery = queryOrFunc(prevQuery);
                return (0, exports.stringifyQuery)(newQuery, stringifyOptions);
            }
            return (0, qs_1.stringify)(queryOrFunc, stringifyOptions);
        });
    }, [parseOptions, setSearchParams, stringifyOptions]);
    return [query, setQuery];
};
exports.useQueryString = useQueryString;
//# sourceMappingURL=index.js.map